import React, { ReactElement } from 'react'
import { Flex, Text } from '@theme-ui/components'
import CopyToClipboard from 'components/CopyToClipboard'
import { DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import useGetColorMode from 'utils/useGetColorMode'
import { Button } from 'ui'

export default function AndroidInstructions({ code }: { code: string }): ReactElement {
  const { isLightMode } = useGetColorMode()
  return (
    <Flex
      sx={{
        width: ['100%', '48rem'],
        maxHeight: '100%',
        py: '4rem',
        px: ['1.2rem', '4rem'],
        flexDirection: 'column',
        gap: '3.2rem',
        alignItems: 'center',
        textAlign: 'center',
        overflowY: 'auto',
      }}
      className={`show-scrollbar ${isLightMode ? 'light' : 'dark'}`}
    >
      <Text variant="size14Weight400Line138" sx={{ color: 'aliceBlue', maxWidth: '39rem' }}>
        Use the token below to provision your Android device(s).
      </Text>
      <Flex
        data-testid="android-token-container"
        sx={{
          width: ['100%', '39rem'],
          backgroundColor: 'white6',
          p: '1.6rem',
          borderRadius: '1.2rem',
          textAlign: 'left',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text variant="size12Weight500" sx={{ color: 'aliceBlue' }}>
          {code}
        </Text>
        <CopyToClipboard smallIcon data={code} fillSvg="aliceBlue60" />
      </Flex>
      <Text variant="size14Weight400Line138" sx={{ color: 'aliceBlue', maxWidth: '39rem' }}>
        For step-by-step guidance, please refer to the documentation.
      </Text>
      <Button
        variant="newSecondary"
        ariaLabel="open android enterprise deployment doc"
        sx={{
          width: 'fit-content',
          border: 'none',
          height: '3.8rem',
          px: '2.4rem',
        }}
        onClick={() => {
          window.open(
            `${DOCS_CONTROL_D_DOMAIN}/docs/android-enterprise-deployment`,
            '_blank',
            'noopener, noreferrer',
          )
        }}
      >
        View Documentation
      </Button>
    </Flex>
  )
}
